<div class="flex flex-1 flex-col gap-2">
  <div class="grid grid-cols-3 border-b border-slate-100 py-1">
    @if (!item.titleReadOnly) {
      <dx-text-box
        [value]="item.config.title"
        (valueChange)="onTitleChange($event)"
        [readOnly]="readonly"
        [valueChangeEvent]="'keyup'"
      ></dx-text-box>
    }

    @if (item.titleReadOnly) {
      <span class="text-base font-bold uppercase text-slate-900">{{
        item.config.title
      }}</span>
    }
  </div>

  @if (item.config?.items?.length > 0) {
    <div class="flex flex-col">
      <ng-container
        [ngTemplateOutlet]="templateOutlet"
        [ngTemplateOutletContext]="{
          $implicit: item.config.items,
          groupName: 'report-designer',
          groupTarget: item.config.name,
          scrollable: false,
          cols: '1',
          level: level + 1,
          parentName: item.config.name,
          templateArrayOwner: item.config,
          templateArrayKey: 'items'
        }"
      ></ng-container>
    </div>
    <div class="h-px bg-slate-100"></div>
  }

  @if (item.config.tabs.length === 0) {
    <div class="flex items-center justify-center p-4">
      <snt-button
        [disabled]="readonly"
        (onClick)="onAdd()"
        [title]="'Aggiungi tab' | transloco"
      ></snt-button>
    </div>
  }
  @if (item.config && item.config.tabs && item.config.tabs.length > 0) {
    <div class="flex flex-col gap-2">
      <dx-sortable
        [data]="item.config.tabs"
        [handle]="'.snt-tab-drag-handle'"
        [dragDirection]="'horizontal'"
        [itemOrientation]="'horizontal'"
        [dropFeedbackMode]="'indicate'"
        [allowReordering]="!readonly"
        class="flex flex-row flex-wrap gap-1 border-b border-slate-200 pb-1"
        (onDragStart)="onTabDragStart($event)"
        (onReorder)="onTabsReorder($event)"
      >
        @for (tab of item.config.tabs; track tab.index) {
          <div
            [ngClass]="{
              'border-slate-400 bg-slate-50': selectedIndex === $index,
              'border-slate-200 border-transparent': selectedIndex !== tab.index
            }"
            class="group flex flex-row items-center gap-2 rounded-md border px-2 py-1 cursor-default"
            (click)="selectedIndex = $index"
          >
            <i
              [class.pointer-events-none]="readonly"
              class="snt-tab-drag-handle fa-light fa-grip-vertical cursor-grab text-slate-400 hover:text-slate-600"
            ></i>

            @if (readonly) {
              <span>{{ tab.name }}</span>
            } @else {
              <dx-text-box
                [value]="tab.name"
                [valueChangeEvent]="'keyup'"
                class="flex-1 min-w-0"
                (click)="$event.stopPropagation()"
                (onFocusIn)="selectedIndex = $index"
                (valueChange)="onTabNameChange(tab, $event)"
              ></dx-text-box>
            }

            <div
              class="ml-auto flex flex-row items-center gap-1 opacity-25 transition-opacity group-hover:opacity-100"
              (click)="$event.stopPropagation()"
            >
              <snt-button-icon
                [disabled]="readonly"
                (onClick)="onRemove(tab)"
                [size]="'xs'"
                icon="fa-light fa-trash"
              ></snt-button-icon>

              @if ($index === item.config.tabs.length - 1) {
                <snt-button-icon
                  [disabled]="readonly || item.config.tabs.length > 4"
                  [sntTooltip]="
                    item.config.tabs.length > 4
                      ? ('Hai raggiunto il numero massimo di tab' | transloco)
                      : ('Aggiungi un nuovo tab' | transloco)
                  "
                  [size]="'xs'"
                  icon="fa-light fa-circle-plus"
                  (onClick)="onAdd()"
                ></snt-button-icon>
              }
            </div>
          </div>
        }
      </dx-sortable>

      <div class="flex h-min px-2">
        <ng-container
          [ngTemplateOutlet]="templateOutlet"
          [ngTemplateOutletContext]="{
            $implicit: item.config.tabs[selectedIndex]?.items ?? [],
            groupName: 'report-designer',
            groupTarget: item.config.name,
            scrollable: false,
            cols: '1',
            level: level + 1,
            parentName: item.config.name,
            templateArrayOwner: item.config.tabs[selectedIndex],
            templateArrayKey: 'items'
          }"
        ></ng-container>
      </div>
    </div>
  }
</div>
